module.exports = __webpack_public_path__ + "static/media/349GriffinStNW_2018-06-05_49.31235782.jpg";